<button class="toolbar-btn" [ngClass]="buttonClass" aria-label="butt"><ng-content></ng-content></button>
